import React, { Component } from 'react';
import {
	Carousel,
	CarouselItem,
	CarouselControl,
	CarouselIndicators,
	CarouselCaption,
	Button,
	Modal,
	ModalBody,
	Col,
	Row,
	Container,
	ModalFooter,
} from 'reactstrap';

import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';

import './BoasVindas.scss';

const items = [
	{
		src:
			'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa1d%20text%20%7B%20fill%3A%23555%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa1d%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22285.921875%22%20y%3D%22218.3%22%3EFirst%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
		altText: 'Slide 1',
		caption: 'Slide 1',
	},
	{
		src:
			'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa20%20text%20%7B%20fill%3A%23444%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa20%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23666%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22247.3203125%22%20y%3D%22218.3%22%3ESecond%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
		altText: 'Slide 2',
		caption: 'Slide 2',
	},
	{
		src:
			'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa21%20text%20%7B%20fill%3A%23333%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa21%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23555%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22277%22%20y%3D%22218.3%22%3EThird%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
		altText: 'Slide 3',
		caption: 'Slide 3',
	},
];

const abrirManual = () => {
	var url = 'https://grupo.econeteditora.com.br/lp/gnre-manual-Copia/';
	var win = window.open(url, '_blank');
	win.focus();
};

class BoasVindas extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			// step: 'ShowPrimeirosPassos',
			step: 'Default',
			activeIndex: 0,
		};
	}

	handleReset = () => {
		this.setState({ step: 'Default', activeIndex: 0 });
	};

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		HttpUtil.eco_PUT(`${Config.urls.API_URL_BASE}Acesso/SalvarPrimeiroAcesso`, {}).then(() => {
			localStorage.setItem('PrimeiroAcesso', false);
			this.setState({ isOpen: false });
		});
	};

	handleModalClosed = () => {
		this.handleReset();
	};

	onExiting = () => {
		this.animating = true;
	};

	onExited = () => {
		this.animating = false;
	};

	next = () => {
		if (this.animating) return;
		const nextIndex = this.state.activeIndex === items.length - 1 ? items.length - 1 : this.state.activeIndex + 1;
		this.setState({ activeIndex: nextIndex });
	};

	previous = () => {
		if (this.animating) return;
		const nextIndex = this.state.activeIndex === 0 ? 0 : this.state.activeIndex - 1;
		this.setState({ activeIndex: nextIndex });
	};

	goToIndex = newIndex => {
		if (this.animating) return;
		this.setState({ activeIndex: newIndex });
	};

	redirectGuias() {
		if (window.location.pathname !== '/pendentes') {
			window.location.href = '/pendentes';
		} else {
			window.location.reload(true);
			document.location.reload(true);
		}
		this.closeModal();
	}

	renderModalCarousel = () => {
		const { activeIndex } = this.state;
		const slides = items.map(item => {
			return (
				<CarouselItem onExiting={this.onExiting} onExited={this.onExited} key={item.src}>
					<img src={item.src} alt={item.altText} />
					<CarouselCaption captionText={item.caption} captionHeader={item.caption} />
				</CarouselItem>
			);
		});

		return (
			<Modal
				size="lg"
				id="modal-boas-vindas-carousel"
				centered={true}
				isOpen={this.state.isOpen}
				onClosed={this.handleModalClosed}
				backdrop="static">
				<ModalBody>
					<Carousel interval={false} activeIndex={activeIndex} next={this.next} previous={this.previous}>
						<CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={this.goToIndex} />
						{slides}
						<CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
						<CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
					</Carousel>
				</ModalBody>
				<ModalFooter>
					<Container>
						<Row className="justify-content-end">
							<Col xs="auto">
								{this.state.activeIndex === items.length - 1 ? (
									<Button block onClick={() => this.redirectGuias()}>
										Finalizar
									</Button>
								) : (
									<Button color="info" block onClick={() => this.closeModal()}>
										Pular
									</Button>
								)}
							</Col>
						</Row>
					</Container>
				</ModalFooter>
			</Modal>
		);
	};

	renderModalDefault() {
		return (
			<Modal
				size="lg"
				id="modal-boas-vindas"
				centered={true}
				isOpen={this.state.isOpen}
				onClosed={this.handleModalClosed}
				backdrop="static">
				<ModalBody>
					<img src="/img/logo-boas-vindas.png" alt="Logo Boas Vindas" />
					<h1>Seja bem vindo!</h1>
					<h2>EcoGNRE, o Emissor de Guias inteligente da Econet Editora.</h2>
					{/* <p>Quer ajuda para utilizar o sistema?</p>
					<p>Preparamos alguns passos que serão muito úteis em sua utilização.</p> */}
				</ModalBody>

				<div className="versao2" >
						<h1 className="v2-tittle">ECOGNRE AGORA NA VERSÃO 2.0!</h1>
						<h2 className="v2-subtittle">Atualização disposta pelo Ajuste SINIEF 009/2018. Confira as novidades no manual.</h2>
				</div>

				<ModalFooter>
					<Container>
						<Row className="justify-content-between">
							<Col xs="auto">
								<Button color="primary" block onClick={() => abrirManual()}>
									Manual do Usuário
								</Button>
							</Col>
							<Col xs="auto">
								<Button color="info" block onClick={() => this.closeModal()}>
									Fechar
								</Button>
							</Col>
							{/* <Col xs="auto">
								<Button
									block
									onClick={() => this.setState({ step: 'ShowPrimeirosPassos' })}
									color="primary">
									Primeiros passos
								</Button>
							</Col> */}
						</Row>
					</Container>
				</ModalFooter>
			</Modal>
		);
	}

	renderModal() {
		switch (this.state.step) {
			case 'ShowPrimeirosPassos':
				return this.renderModalCarousel();

			default:
				return this.renderModalDefault();
		}
	}

	render = () => this.renderModal();
}

export default BoasVindas;
